import { render, staticRenderFns } from "./modify-password-form.vue?vue&type=template&id=fd4a1c56&scoped=true&"
import script from "./modify-password-form.vue?vue&type=script&lang=js&"
export * from "./modify-password-form.vue?vue&type=script&lang=js&"
import style0 from "./modify-password-form.vue?vue&type=style&index=0&id=fd4a1c56&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4a1c56",
  null
  
)

export default component.exports